import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import * as product from '@/api/ProductApi'
import * as ProductHelper from '@repo/helpers/product'

// Clean up meta data for direct access.
function assignData(data) {
  const { meta, ...content } = data
  const domain = import.meta.env.VITE_SITE_DOMAIN
  // const url = `${domain}${meta.meta.url}`
  const url = import.meta.env.DEV
    ? `${domain}:${import.meta.env.VITE_PORT}${meta.meta.url}`
    : `${domain}${meta.meta.url}`
  const pageMeta = {
    title: meta.title || '',
    description: meta.meta.description || '',
    card: meta.meta.card || '',
    url: url || '',
    image: meta.meta.image || '',
    ogType: meta.meta.ogType || '',
  }

  return { meta: pageMeta, content: content }
}

export const useProductsStore = defineStore('products', () => {
  // initial state
  // state: () => ({
  // const loadingMultifunctionalPrinters = ref(true)
  // const loadingOfficePrinters = ref(true)
  // const loadingProductionPrinters = ref(true)
  // const loadingPlotterPrinters = ref(true)
  const loadingFeaturedPrinters = ref(true)

  const products = ref({})
  // Printer products
  // const multifunctionalsPrinters = ref({
  //   count: 0,
  //   results: [],
  //   loaded: false,
  //   loadedItemsCount: 0,
  // })
  // const printOnlyPrinters = ref({
  //   count: 0,
  //   results: [],
  //   loaded: false,
  //   loadedItemsCount: 0,
  // })
  // const productionPrinters = ref({
  //   count: 0,
  //   results: [],
  //   loaded: false,
  //   loadedItemsCount: 0,
  // })
  // const plotters = ref({
  //   count: 0,
  //   results: [],
  //   loaded: false,
  //   loadedItemsCount: 0,
  // })
  // const all = ref({
  //   count: 0,
  //   results: [],
  //   loaded: false,
  //   loadedItemsCount: 0,
  // })
  // // Scanner products)
  // const allScanners = ref({
  //   count: 0,
  //   results: [],
  //   loaded: false,
  //   loadedItemsCount: 0,
  // })
  // const personalScanners = ref({
  //   count: 0,
  //   results: [],
  //   loaded: false,
  //   loadedItemsCount: 0,
  // })
  // const departmentalScanners = ref({
  //   count: 0,
  //   results: [],
  //   loaded: false,
  //   loadedItemsCount: 0,
  // })
  // const productionScanners = ref({
  //   count: 0,
  //   results: [],
  //   loaded: false,
  //   loadedItemsCount: 0,
  // })
  // const desktopWorkgroupScanners = ref({
  //   count: 0,
  //   results: [],
  //   loaded: false,
  //   loadedItemsCount: 0,
  // })
  const featuredProducts = ref({})
  const selected = ref({
    /* Holds data for currently viewed page */
  })
  const productMeta = ref({
    title: '',
    description: '',
    url: '',
    image: '',
    card: '',
    ogType: '',
  })

  // Getters
  // const allProducts = computed(() =>
  //   multifunctionalsPrinters.value.results.concat(printOnlyPrinters.value.results)
  // )
  const viewSingleProduct = computed(() => selected.value.content)
  const getProductMeta = computed(() => selected.value.meta)

  // Product actions
  // actions: {
  function toggleLoadingProducts() {
    this.SET_PRODUCT_LOADING()
  }

  // Load all active printers

  async function getAllPrinters(limit, offset, append = false) {
    const data = await product.getAllPrinters(limit, offset)
    SET_ALL_PRODUCTS(data, limit, offset, append)
  }

  const createCategoryState = () => ({
    count: 0,
    results: [],
    loaded: false,
    loadedItemsCount: 0,
  })

  async function getProductsByCategory(productCategory, options = {}) {
    const {
      category,
      limit, // Default values here
      offset,
    } = options
    if (!products.value[productCategory]) {
      products.value[productCategory] = createCategoryState()
    }

    if (products.value[productCategory].results.length > 0) {
      return
    }

    const data = await product.getProductByCategory(productCategory, { category, limit, offset })
    SET_PRODUCT_DATA(productCategory, data)
  }

  async function FETCH_FEATURED_PRODUCTS() {
    // Only load featured printers if we don't ahve them already
    if (featuredProducts.value.length > 0) {
      return
    } else {
      const data = await product.getFeaturedPrinters()
      SET_FEATURED_PRODUCTS(data.results)
      SET_FEATURED_PRINTERS_LOADING(false)
    }
  }

  async function FETCH_PRODUCT(request) {
    const { type, modelId } = request

    const productData = await product.getSingleProduct(modelId)
    // const slug = modelId --> unused
    // Test for valid product
    if (!productData) {
      throw { code: 404, request: JSON.stringify(request) }
    }

    return SET_SINGLE_PRODUCT(productData)
  }

  async function FETCH_PRINTER(request) {
    const modelId = request.modelId

    let remoteType = []
    // Check type is valid first
    switch (request.type) {
      case 'multifunctionals':
      case 'print-only':
      case 'production':
      case 'light-production':
      case 'mid-production':
      case 'heavy-production':
      case 'plotter':
        break
      default:
        // console.log('boop', request.type, modelId, request)
        throw { statusCode: 404, request: JSON.stringify(request) }
    }

    if (request.type === 'multifunctionals') {
      remoteType = ['multifunctional-printer']
    }

    if (request.type === 'print-only') {
      remoteType = ['office-printer']
      remoteType = ['printer']
    }
    if (request.type === 'plotter') {
      remoteType = ['plotter']
    }

    if (request.type === 'production') {
      remoteType = [
        'multifunctional-printer',
        'office-printer',
        'light-production-printer',
        'light-production',
        'mid-production-printer',
        'mid-production',
        'heavy-production-printer',
        'heavy-production',
        'plotter',
      ]
    }
    const productData = await product.getSingleProduct(modelId)
    // const slug = modelId --> unused
    // Test for valid product
    if (!productData) {
      throw { code: 404, a: 1, request: JSON.stringify(request) }
    }

    // Check if productData.type matches remoteType
    if (!remoteType.includes(productData.productCategory)) {
      throw new Error(
        `Product type mismatch: ${productData.productCategory} not in ${remoteType} ${JSON.stringify(request)}`
      )
    }

    if (productData.isActive !== 1) {
      throw new Error(`Product is not active: ${JSON.stringify(request)}`)
    }

    return SET_SINGLE_PRODUCT(productData)
  }
  async function FETCH_SCANNER(request) {
    const modelId = request.modelId
    // return new Promise((resolve, reject) => {
    // console.log('FETCH_SCANNER', request)
    let remoteType
    // Check type is valid first
    console.log(request)
    switch (request.type) {
      case 'production':
      case 'production-scanner':
      case 'departmental':
      case 'desktop-workgroup':
      case 'personal':
        break
      default:
        // console.log('beep', request.type, modelId)
        throw new Error({ code: 404, request: JSON.stringify(request), m: 'first' })
    }

    // TODO: Check this over, this is just a hack tog et this working

    remoteType = [
      'production-scanners',
      'departmental-scanners',
      'desktop-workgroup-scanners',
      'personal-scanners',
      'scanner',
    ]

    const productData = await product.getSingleScanner(modelId)
    // console.log('productData', productData)
    // const slug = modelId --> unused

    // Test for valid product
    if (!productData) {
      throw {
        code: 404,
        request: JSON.stringify(request),
        m: 'productData)',
      }
    }

    // Check if productData.type matches remoteType
    if (!remoteType.includes(productData.productCategory)) {
      throw new Error(
        `Product type mismatch: ${productData.productCategory} not in ${remoteType} ${JSON.stringify(request)}`
      )
    }

    if (!productData.isActive) {
      throw new Error(`Product is not active: ${JSON.stringify(request)}`)
    }

    SET_SINGLE_PRODUCT(productData)
  }
  async function FETCH_RELATED_PRINTERS(modelId) {
    const result = {
      modelId,
    }
    return product.getSimiliarPrinters(modelId).then((data) => {
      result.printers = data
      SET_RELATED_PRINTERS(result)
    })
  }
  function SET_PRODUCT_DATA(category, data) {
    const { count, results } = data
    // console.log(data, count, results, limit, offset)
    // if (count === 0) {
    //   products.value[category].results = []
    //   products.value[category].count = 0
    //   products.value[category].loaded = true
    //   products.value[category].loadedItemsCount = 0
    //   // console.log(`[State Updated] No items. Count: ${products.value[category].count}, Loaded: ${products.value[category].loaded}`);
    //   return
    // }

    products.value[category].count = results.length
    products.value[category].results = results
    products.value[category].loaded = true
  }
  // function SET_PRODUCT_DATA(category, data, limit, offset, append = false) {
  //   const { count, results } = data
  //   console.log(data, count, results, limit, offset)
  //   if (count === 0) {
  //     products.value[category].results = []
  //     products.value[category].count = 0
  //     products.value[category].loaded = true
  //     products.value[category].loadedItemsCount = 0
  //     // console.log(`[State Updated] No items. Count: ${products.value[category].count}, Loaded: ${products.value[category].loaded}`);
  //     return
  //   }
  //   // if (
  //   //   products.value[category].results.length !== count ||
  //   //   products.value[category].count !== count
  //   // ) {
  //   //   // const oldResults = [...products.value[category].results] // Preserve old items temporarily
  //   //   // const oldLoadedItemsCount = products.value[category].loadedItemsCount
  //   //   // Initialise our results array to the eventual size
  //   //   products.value[category].results = new Array(count).fill(null)
  //   //   products.value[category].count = count
  //   //   products.value[category].loadedItemsCount = 0

  //   //   // This is important if 'count' changes mid-loading process
  //   //   // This shouldnt be needed
  //   //   // for (let i = 0; i < Math.min(oldResults.length, count); i++) {
  //   //   //   if (oldResults[i] !== null) {
  //   //   //     // If it was actual data
  //   //   //     products.value[category].results[i] = oldResults[i]
  //   //   //     products.value[category].loadedItemsCount++
  //   //   //   }
  //   //   // }
  //   // }

  //   // let itemsActuallyWrittenThisCall = 0
  //   // for (let i = 0; i < results.length; i++) {
  //   //   const targetIndex = offset + i

  //   //   // Ensure targetIndex is within the bounds of the results array
  //   //   if (targetIndex < products.value[category].results.length) {
  //   //     if (products.value[category].results[targetIndex] === null) {
  //   //       // Check if slot is empty
  //   //       products.value[category].results[targetIndex] = results[i]
  //   //       products.value[category].loadedItemsCount++ // Increment count of loaded items
  //   //       itemsActuallyWrittenThisCall++
  //   //     }
  //   //     // If productState.results[targetIndex] is NOT null, it means data for this slot
  //   //     // was already fetched and placed. We skip it to prevent overwriting.
  //   //   } else {
  //   //     // This case should ideally not happen if 'count' from API is consistent
  //   //     // and 'offset' is managed correctly.
  //   //     // console.warn(`[State Update] Target index ${targetIndex} is out of bounds for results array of length ${productState.results.length}. Item not placed.`);
  //   //   }
  //   }

  //   // if (products.value[category].count > 0) {
  //   //   products.value[category].loaded =
  //   //     products.value[category].loadedItemsCount === products.value[category].count
  //   // } else {
  //   //   // If count is 0 (handled at the start), it's technically loaded as there's nothing to load.
  //   //   products.value[category].loaded = true
  //   // }
  // }
  // function SET_MULTIFUNCTIONAL_PRODUCTS(data, append = false) {
  //   const { count, results } = data
  //   console.log(count, results)
  //   if (multifunctionals.results.length === 0 && count > 0) {
  //     // Initialise our results array to the eventual size
  //     multifunctionals.results = new Array(count)
  //   }

  //   this.multifunctionals.count = count
  //   if (append) {
  //     this.multifunctionals.results.push(...results)
  //   } else {
  //     this.multifunctionals.results = results
  //   }
  // }
  // function SET_OFFICE_PRODUCTS(data, append = false) {
  //   const { count, results } = data
  //   this.printOnly.count = count
  //   if (append) {
  //     this.printOnly.results.push(...results)
  //   } else {
  //     this.printOnly.results = results
  //   }
  // }
  // function SET_PRODUCTION_PRODUCTS(data, append = false) {
  //   const { count, results } = data
  //   this.production.count = count
  //   if (append) {
  //     this.production.results.push(...results)
  //   } else {
  //     this.production.results = results
  //   }
  // }

  // function SET_PLOTTER_PRODUCTS(data, append = false) {
  //   const { count, results } = data
  //   this.plotter.count = count
  //   if (append) {
  //     this.plotter.results.push(...results)
  //   } else {
  //     this.plotter.results = results
  //   }
  // }

  // function SET_SCANNER_PRODUCTS(data, append = false) {
  //   const { count, results } = data
  //   this.scanner.count = count
  //   if (append) {
  //     this.scanner.results.push(...results)
  //   } else {
  //     this.scanner.results = results
  //   }
  // }

  function SET_SINGLE_PRODUCT(body, append = false) {
    const data = assignData({
      ...body,
      meta: ProductHelper.getProductMeta(body),
    })

    selected.value = data
    return true
  }

  function SET_RELATED_PRINTERS(data) {
    related.value[data.modelId] = data.printers
  }
  function SET_FEATURED_PRODUCTS(products) {
    featuredProducts.value = products
  }
  function SET_MULTIFUNCTIONAL_PRINTERS_LOADING(value) {
    loadingMultifunctionalPrinters.value = value
  }
  function SET_PRODUCTION_PRINTERS_LOADING(value) {
    loadingProductionPrinters.value = value
  }
  function SET_PLOTTER_PRINTERS_LOADING(value) {
    loadingPlotterPrinters.value = value
  }
  function SET_FEATURED_PRINTERS_LOADING(value) {
    loadingFeaturedPrinters.value = value
  }
  function SET_OFFICE_PRINTERS_LOADING(value) {
    loadingOfficePrinters.value = value
  }
  function SET_PRODUCT_META(content) {
    const { slug, data } = content
    const pageMeta = {
      title: data.meta.title || '',
      description: data.meta.meta.description || '',
      card: data.meta.meta.card || '',
      url: process.SITE_DOMAIN + data.meta.meta.url || '',
      image: data.meta.meta.image || '',
      ogType: data.meta.meta.ogType || '',
    }

    productMeta.value[slug] = pageMeta
  }
  // },

  // getters
  // getters: {
  // getProductPageContent: (state) => state.selected,
  // viewProducts: (state) => state.multifunctionals.results.concat(state.office),
  // viewMultifunctionalPrinters: (state) => state.multifunctionals,
  // viewProductionPrinters: (state) => state.production,
  // viewPlotterPrinters: (state) => state.plotter,
  // viewScanners: (state) => state.allScanners,
  // viewOfficePrinters: (state) => state.printOnly,
  // viewSingleProduct: (state) => state.selected.content,
  // featuredProducts: (state) => state.featured,
  // getProductMeta: (state) => state.selected.meta,
  // isProductLoaded: (state, getters) => {
  //   if (getters.isProductDataLoading) {
  //     return false
  //   } else {
  //     return true
  //   }
  // },
  // },

  return {
    // loadingMultifunctionalPrinters,
    // loadingOfficePrinters,
    // loadingProductionPrinters,
    // loadingPlotterPrinters,
    loadingFeaturedPrinters,
    // multifunctionalsPrinters,
    // printOnlyPrinters,
    // productionPrinters,
    // plotters,
    // all,
    // allScanners,
    // personalScanners,
    // departmentalScanners,
    // productionScanners,
    // desktopWorkgroupScanners,
    products,
    featuredProducts,
    selected,
    productMeta,
    // Getters
    // allProducts,
    viewSingleProduct,
    getProductMeta,
    // Actions
    // getAllPrinters,
    getProductsByCategory,
    // getMultifunctionalPrinters,
    // getOfficePrinters,
    // getProductionPrinters,
    // getPlotterPrinters,
    // getAllScanners,
    // getPersonalScanners,
    // getDepartmentalScanners,
    // getProductionScanners,
    // getDesktopWorkgroupScanners,
    // getWorkgroupScanners,
    FETCH_FEATURED_PRODUCTS,
    FETCH_PRODUCT,
    FETCH_PRINTER,
    FETCH_SCANNER,
    FETCH_RELATED_PRINTERS,
  }
})
